import { colors, fonts } from '@grupoboticario/flora-tokens/dist/drJones/web/ds'

export const drJones = {
  colors,
  fonts,
}
